// styles.js
import { makeStyles } from "@material-ui/core";

 const useStyles = makeStyles((theme) => ({
   root: {
     marginTop: theme.spacing(1),
   },
   button: {
     marginTop: theme.spacing(2),
     background: "linear-gradient(90deg, #0A2D71 0%, #133984 100%)",
   },
   resetBtn: {
     background: "linear-gradient(90.49deg, #373738 -0.38%, #565656 99.9%);",
   },
   rejectBtn: {
     background: "linear-gradient(90deg, #A21717 0%, #A91067 100%);",
   },
   stepperRoot: {
     margin: theme.spacing(2, 4),
     boxShadow:
       "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;",
     backgroundColor: "#f9f9f9",
     borderRadius: theme.shape.borderRadius,
   },
   notification: {
     backgroundColor: theme.palette.background.paper,
     color: theme.palette.text.primary,
     padding: theme.spacing(2),
     borderRadius: theme.shape.borderRadius,
     boxShadow: theme.shadows[3],
     "&.success": {
       borderLeft: `4px solid ${theme.palette.success.main}`,
     },
     "&.error": {
       borderLeft: `4px solid ${theme.palette.error.main}`,
     },
     "&.info": {
       borderLeft: `4px solid ${theme.palette.info.main}`,
     },
   },
   documentContainer: {
     margin: theme.spacing(2, 4),
   },
   finishButtonContainer: {
     display: "flex",
     justifyContent: "space-between",
     alignItems: "center",
     marginTop: theme.spacing(2),
   },
   validationMessage: {
     marginLeft: theme.spacing(2),
   },
   headerContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
   },
   backButton: {
     flex: "none",
     order: 0,
     flexGrow: 0,
     background: "linear-gradient(90deg, #0A2D71 0%, #133984 100%);",
     color: "#fff",
   },
 }));

export default useStyles;